import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Search} from '../models/search';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private http: HttpClient) {
  }

  findLocations(search: string, showInvisible = false, showNoSeats = false, limit = 1000, skip = 0) {
    const params = {search, showInvisible, showNoSeats, limit, skip};
    return this.http.get<Search[]>(`${API}/api/searches/location`, {params});
  }

  findMeetings(search: string, showInvisible = false, limit = 1000, skip = 0) {
    const params = {search, showInvisible, limit, skip};
    return this.http.get<Search[]>(`${API}/api/searches/meeting`, {params});
  }
}
